import CrudRepository from './CrudRepository'
export default class ContactUsRepository extends CrudRepository {
  constructor () {
    super('customerCare/api/contactInfo/web')
  }
}
